<ct-lib-modal [small]="size !== 'lg'" [label]="label ? label : 'ct-library.confirm-modal.title' | transloco"
  [closeable]="false" [footer]="footer" (onOpen)="onOpen.emit()" (onOpenEnd)="onOpenEnd.emit()"
  (onClose)="onClose.emit()" (onCloseEnd)="onCloseEnd.emit()" #modal>
  <ng-content></ng-content>
</ct-lib-modal>

<ng-template #footer>
  @if (!hideCancelButton) {
    <button class="ct-btn ct-btn-white-grey" (click)="this.cancel()">
      {{ cancelLabel ? cancelLabel : 'ct-library.confirm-modal.button-cancel' | transloco}}
    </button>
  }
  @if (!hideConfirmButton) {
    <button class="ct-btn ct-btn-primary" [disabled]="disableConfirmButton" (click)="this.confirm()">
      {{ confirmLabel ? confirmLabel : 'ct-library.confirm-modal.button-confirm' | transloco}}
    </button>
  }
</ng-template>